export const gifImages = [
    // LIBIDINAL, 2019
    {
      src: "Art-Site/Gifs/Dyson-Bidet-10fps_ercbxv.gif",
      caption: "Dyson Bidet, 2019",
    },
    {
      src: "Art-Site/Gifs/TechnoSpa-500pxw50websnap_meqocr.gif",
      caption: "Techno Spa Tunnel, 2018",
    },
    {
      src: "Art-Site/Gifs/RippleMaze-500px-5fps_txsvp2.gif",
      caption: "Ripple Maze, 2019",
    },
    {
      src: "Art-Site/Gifs/aoto-spiral-500pw-5fps-112colors_rmxvhf.gif",
      caption: "Aoo Spiral, 2016",
    },
  // MODULAR LANDSCAPES, 2016
  {
    src: "Art-Site/lavastorm.gif",
    caption: "Lava Storm from Modular Landscapes, 2016",
  },
  {
    src: "Art-Site/modular-landscapes-daytimefog.gif",
    caption: "Daytime Fog from Modular Landscapes, 2016",
  },
  {
    src: "Art-Site/dustysky.gif",
    caption: "Dust Storm from Modular Landscapes, 2016",
  },
  // LAURIE, 2015
  {
    src: "Art-Site/laurie.gif",
    caption: "Flashback from Great Aunt's Rose Garden's environment",
  },
  // DISCRETE SYSTEMS
  {
    src: "Art-Site/DiscreteSystems-Funnel-Shots.gif",
    caption: "Funnel Track from Discrete Systems",
  },
  // ROSE GARDEN
  {
    src: "Art-Site/rosegarden-flashback.gif",
    caption: "Flashback from Great Aunt's Rose Garden's environment",
  },
  {
    src: "Art-Site/greatAunts-garden-short.gif",
    caption: "A short gif from Great Aunt's Rose Garden's environment",
  },
  // INNER SELVES, 2015
  {
    src: "Art-Site/innerself-landscapeportrait.gif",
    caption: "Innerself Landscape Portrait",
  },
  // UNDER CONSTRUCTION, 2013
  {
    src: "Art-Site/eilis-underconstruction-rocks.gif",
    caption:
      "Building a wall at the edge of the universe to keep it from expanding, 2013",
  },
  // SENSUAL OBJECTS June 2015
  {
    src: "Art-Site/sensualobjects-purplehairy.gif",
    caption: "Sensual Objects, Purple Hairy, 2015",
  },
  {
    src: "Art-Site/sensualobjects-bootycam-orange.gif",
    caption: "Sensual Objects, Booty Cam Orange, 2015",
  },
  // BLOBS
  {
    src: "Art-Site/Night-Marie-Moon.gif",
    caption: "Night Marie Moon, 2015",
  },
  {
    src: "Art-Site/Algo-blob.gif",
    caption: "Algo Blob #3, 2013",
  },
  {
    src: "Art-Site/psych-window.gif",
    caption: "Psychedelic Window Smiley, 2015",
  },
  {
    src: "Art-Site/dizty-shape.gif",
    caption: "Short gif from Bubble Motion environment, 2014",
  },
  {
    src: "Art-Site/Gallery-Blob-12-01-13.gif",
    caption: "Gallery Blobber gif, 2013",
  },
  // ICOSA SHAPES 04/2015
  {
    src: "Art-Site/icosashape-tikipink.gif",
    caption: "Icosa Shapes iteration in Triple Pink , 2015",
  },
  {
    src: "Art-Site/icosashape-greentransparent.gif",
    caption: "Icosa Shapes iteration in Transparent Green , 2015",
  },
  //GIFWRAPPING, LUMP OF COAL, 2014
  {
    src: "Art-Site/gifwrapping-coal-2.gif",
    caption: "A lump of goal, 2014",
  },

  // WOMB STRETCH
  {
    src: "Art-Site/wombstrech-full.gif",
    caption: "Womb Stretch, 2015",
  },
  // KITCHEN WALLPAPER 2012
  {
    src: "Art-Site/kitchen-wallpaper-new-algo-green.gif",
    caption: "Kitchen Wallpaper, New Green Algo, 2012",
  },
  // CLITS
  {
    src: "Art-Site/pinkflyingclits.gif",
    caption: "Flying Clits, 2016",
  },
  //LAZURITE
  {
    src: "Art-Site/purple-lazurite.gif",
    caption: "Short gif from Lazurite Music Video alternate, 2014",
  },
  {
    src: "Art-Site/lazurite.gif",
    caption: "Short gif from Lazurite Music Video alternate, 2014",
  },
  // XMAL DEUTCHBLOBS
  {
    src: "Art-Site/xmaldeustchblobs-PUNKFAST.gif",
    caption: "Short gif from Xmal Deutchblobs, 2013",
  },
  // ALIEN SHIP, 2015
  {
    src: "Art-Site/selfiwship.gif",
    caption: "Alien Ship Self Portrait, 2015",
  },
  //BLACK AND CRIMSON, 2014
  {
    src: "Art-Site/black-and-crimson.gif",
    caption: "Black and Crimson, 2013",
  },
  //CLUTCHING FOR LEAD, 2013
  {
    src: "Art-Site/hand-clutching-for-lead.gif",
    caption: "Clutching for Lead after Richard Serra, 2013",
  },
];
